var _path, _path2, _path3, _path4, _g, _g2, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomateEverything(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 611 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.466 96.7193C357.785 103.266 336.687 116.788 319.178 144.957C303.463 170.24 286.369 183.113 265.288 189.532C244.538 195.85 220.06 195.85 189.848 195.85H189.479V190.485C220.125 190.485 243.818 190.461 263.725 184.4C283.385 178.413 299.487 166.473 314.621 142.124C332.828 112.833 354.986 98.5242 376.847 91.6043C397.296 85.1314 417.399 85.1652 433.315 85.192C434.318 85.1937 435.304 85.1953 436.273 85.1953V90.5604C435.337 90.5604 434.389 90.559 433.428 90.5577C417.431 90.5346 398.093 90.5067 378.466 96.7193Z",
    fill: "#EAFF6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.617 162.458C357.502 164.757 336.278 169.488 318.868 179.121C287.415 196.525 251.235 196.525 190.918 196.525L190.149 196.525V191.16C251.426 191.16 286.159 191.088 316.271 174.427C334.576 164.298 356.608 159.457 378.036 157.125C398.224 154.927 418.08 154.938 434.017 154.946C435.008 154.947 435.983 154.948 436.943 154.948V160.313C435.996 160.313 435.036 160.312 434.062 160.312C418.09 160.303 398.503 160.293 378.617 162.458Z",
    fill: "#EAFF6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.466 290.966C357.785 284.42 336.687 270.898 319.178 242.729C303.463 217.446 286.369 204.573 265.288 198.154C244.538 191.835 220.06 191.835 189.848 191.836L189.479 191.836L189.479 197.201C220.125 197.201 243.818 197.224 263.725 203.286C283.385 209.272 299.487 221.213 314.621 245.561C332.828 274.852 354.986 289.161 376.847 296.081C397.296 302.554 417.399 302.52 433.315 302.494C434.318 302.492 435.304 302.49 436.273 302.49L436.273 297.125C435.337 297.125 434.389 297.127 433.428 297.128C417.431 297.151 398.093 297.179 378.466 290.966Z",
    fill: "#EAFF6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.617 225.227C357.502 222.928 336.278 218.197 318.868 208.563C287.415 191.159 251.235 191.16 190.918 191.16L190.149 191.16L190.149 196.525C251.426 196.525 286.159 196.596 316.271 213.258C334.576 223.387 356.608 228.227 378.036 230.56C398.224 232.758 418.08 232.747 434.017 232.738C435.008 232.738 435.983 232.737 436.943 232.737L436.943 227.372C435.996 227.372 435.036 227.372 434.062 227.373C418.09 227.381 398.503 227.392 378.617 225.227Z",
    fill: "#EAFF6D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_85_31575)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188.809,
    cy: 192.501,
    r: 34.873,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_85_31575)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 435.604,
    cy: 227.374,
    r: 21.4603,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.604,
    cy: 297.119,
    r: 21.4603,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.604,
    cy: 157.627,
    r: 21.4603,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.604,
    cy: 87.8813,
    r: 21.4603,
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.064 178.615L202.064 192.115L182.064 205.615V178.615Z",
    fill: "#093D00",
    stroke: "#093D00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_85_31575",
    x: 137.936,
    y: 141.628,
    width: 101.746,
    height: 101.746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_31575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_85_31575",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_85_31575",
    x: 398.143,
    y: 50.421,
    width: 74.9206,
    height: 284.158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_31575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_85_31575",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateEverything);
export default __webpack_public_path__ + "static/media/automate-everything.79e3f84c24d18fa320938b8e35286c4d.svg";
export { ForwardRef as ReactComponent };